/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';
import { List, Button, Modal, Label, bindMethods } from '../common';
import Form from './Form';

const formatPhone = (num) => {
  if (typeof num === 'string' && num.length === 10) {
    return `(${num.substr(0, 3)}) ${num.substr(3, 3)}-${num.substr(6, 4)}`;
  }
  return num;
};

const isSetupComplete = (softwares) => {
  return !!(softwares && softwares.info && softwares.info.STUDIO_ID);
};

export default class Staff extends React.Component {
  constructor() {
    super();
    this.state = {
      form: false,
      modal: '',
      modalData: {},
    };
    bindMethods(this, ['show', 'close', 'openModal', 'closeModal']);
  }

  componentDidMount() {
    this.props.getStaffMembers();
    this.props.getStaffTypes();
  }

  show(form) {
    this.setState({
      form,
    });
  }

  close() {
    this.setState({
      form: false,
    });
  }

  openModal(modal, modalData) {
    this.setState({
      modal,
      modalData,
    });
  }

  closeModal() {
    this.setState({
      modal: '',
    });
  }

  render() {
    const { show, close, state, openModal, closeModal } = this;
    const { form, modal, modalData } = state;
    const { saveStaff, removeStaff, softwares } = this.props;
    let staff = [];
    if (this.props.staff && this.props.staff.list && this.props.staff.list.length) {
      staff = this.props.staff.list;
    }

    return (
      <div className="staff">
        <div className="card" style={{ overflow: 'unset' }}>
          <div className="card__header">
            <span className="card__header__text">
              Staff
            </span>
            {
              isSetupComplete(softwares) ?
                <Button
                  className="btn--link"
                  onClick={() => {
                    show({});
                  }}
                >
                  + Add New Staff
                </Button> :
                null
            }
          </div>
          <div className="card__content">
            <div className="voicemails__list">
              <List
                headers={[
                  { label: 'Staff Type' },
                  { label: 'Name' },
                  { label: 'Gender' },
                  { label: 'Email' },
                  { label: 'Phone' },
                  { label: '' },
                ]}
                rows={staff}
                loading={this.props.staff.loading}
              >{(row) => {
                return (
                  <tr
                    key={row.id}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      show(row);
                    }}
                  >
                    <td>{row.staff_type}</td>
                    <td>{`${row.first_name} ${row.last_name}`}</td>
                    <td>{row.gender}</td>
                    <td>{(row.emails || []).map((email) => {
                      return (<div key={Math.random()}>{email}</div>);
                    })}</td>
                    <td>{(row.phones || []).map((phone) => {
                      return (<div key={Math.random()}>{formatPhone(phone)}</div>);
                    })}</td>
                    <td>
                      <i
                        className="material-icons"
                        style={{
                          cursor: 'pointer',
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openModal('del', row);
                        }}
                      >delete</i>
                    </td>
                  </tr>
                );
              }}</List>
            </div>
          </div>
          <Form
            key={(form && form.id) || Math.random()}
            show={!!form}
            values={form}
            onClose={close}
            onSave={saveStaff}
            staffTypes={this.props.staff.types}
          />
          <Modal
            open={modal === 'del'}
            title="Delete Staff Member"
            onClose={() => {
              closeModal();
            }}
          >
            <Label style={{ display: 'block' }} type="form">
              Are you sure you want to delete the staff member:
            </Label>
            <Label style={{ display: 'block' }} type="form">{`${modalData.first_name} ${modalData.last_name}`}</Label>
            <div
              style={{
                textAlign: 'right',
                marginTop: 30,
              }}
            >
              <Button
                type="primary"
                style={{
                  marginRight: 20,
                }}
                onClick={() => {
                  removeStaff(modalData.id);
                  closeModal();
                }}
              >Delete</Button>
              <Button
                type="simple"
                onClick={() => {
                  closeModal();
                }}
              >Close</Button>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

Staff.defaultProps = {
  getStaffMembers: () => {},
  getStaffTypes: () => {},
  saveStaff: () => {},
  removeStaff: () => {},
};

Staff.propTypes = {
  getStaffMembers: PropTypes.func,
  getStaffTypes: PropTypes.func,
  saveStaff: PropTypes.func,
  removeStaff: PropTypes.func,
  staff: PropTypes.shape({
    list: PropTypes.array.isRequired,
    types: PropTypes.array,
    loading: PropTypes.bool,
  }).isRequired,
  softwares: PropTypes.shape({
    info: PropTypes.shape({
      STUIDIO_NAME: PropTypes.string,
    }),
  }).isRequired,
};
